import { Ref, computed, ref } from 'vue'

export type SchedulePublishDialogState = {
  visible: boolean
}

const state: Ref<SchedulePublishDialogState> = ref({
  visible: false,
})

export function useSchedulePublishDialog() {
  const show = () => {
    state.value = { visible: true }
  }

  const hide = () => {
    state.value = { visible: false }
  }

  const isShown = computed(() => state.value.visible)

  return {
    show,
    hide,
    isShown,
  }
}
